const SET_LOCALE_DATA = 'classpass_vp/locale-data/SET_LOCALE_DATA';
export const setLocaleData = (locale, data) => ({
  type: SET_LOCALE_DATA,
  payload: {
    locale,
    ...data,
  },
});

const initialState = {
  locale: 'en-US',
  startWeekOn: 'sun',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCALE_DATA:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
